module.exports = __webpack_public_path__ + "img/truck.8f776636.svg";